import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SharedService } from './../../Service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ChantiersInfrastructuresService } from 'src/app/Service/ChantiersInfrastructures.service';
import { Global } from 'src/app/Service/global.service';
declare var $: any;
@Component({
  selector: 'app-port',
  templateUrl: './port.component.html',
  styleUrls: ['./port.component.scss']
})

export class PortComponent implements OnInit {

  constructor(
    public global: Global,
    private service: ChantiersInfrastructuresService,
    private aroute: ActivatedRoute,
    private shared: SharedService,
    private router: Router
  ) { }
  Chantier = {
    Titre: "",
    Port: "",
    ImageUrl: '',
    Id: 0
  }
  slick;
  Chantiers = [];
  ngOnInit(): void {

    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.aroute.params.subscribe(param => {
        if (this.slick != null) {
          this.Chantiers = [];
          this.slick.slick('destroy');
        }
        if (param['port'] !== null && param['port'] !== undefined) {
          const newurl = lg.url;
          this.service.getChantiersInfrastructuresPagesById(newurl, param['port']).subscribe(datas => {
            //this.service.getChantiersInfrastructuresPagesById(lg.url, param['port']).subscribe(datas => {
            if (datas['value'].length > 0) {
              //const url = this.global._basedUrl + datas['value'][0].File.ServerRelativeUrl;
              const url = this.global._baseUrlStatique + encodeURIComponent(datas['value'][0].File.ServerRelativeUrl);
              this.Chantier.Titre = datas['value'][0].Title ? datas['value'][0].Title : "";
              this.Chantier.Port = datas['value'][0].CodePort ? datas['value'][0].CodePort : "";
              this.Chantier.ImageUrl = datas['value'][0].LienImageProjet !== '' && datas['value'][0].LienImageProjet !== null ? datas['value'][0].LienImageProjet : 'assets/media/images/img-01.png';
              $('#content').load(url, () => {
                $('#content style').remove();
              });
              window.scroll(0, 0);
            } else {
              alert('Page not found !!');
              this.router.navigate(['/']);
            }
          });


          const NewUrl = lg.url;
          this.service.getChantiersInfrastructures(NewUrl).subscribe(datas => {
            //this.service.getChantiersInfrastructures(lg.url).subscribe(data => {
            this.Chantiers = [];
            let i = 0;
            datas["value"].forEach(element => {
              if (element.Id !== +param['port']) {

                const obj = {
                  Titre: element.Title ? element.Title : "",
                  Port: element.CodePort ? element.CodePort : "",
                  Id: element.Id ? element.Id : "",
                  PortImage: element.LienImageProjet !== '' && element.LienImageProjet !== null ? element.LienImageProjet : 'assets/media/images/img-01.png'
                }
                if (i < 6) {
                  this.Chantiers.push(obj);
                  i++;
                }

              }
            })
            setTimeout(() => this.slickContent(lg), 200);
          });
          

        }
      });

    });
  }
  slickContent(lg) {
    if (lg.code != "ar") {
      this.slick = $('#slider-chantier1 ol').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
    else {
      this.slick = $('#slider-chantier1 ol').slick({
        rtl: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }

}
